@if (component(); as galleryData) {
<section class="gallery">
  @if (images().length > 0) {
  <div class="gallery-container">
    <div class="gallery-slider">
      @for (image of images(); track image.id; let i = $index) {
      <div
        class="gallery-slide"
        [class.active]="i === currentImageIndex()"
        [style.transform]="'translateX(' + (i - currentImageIndex()) * 100 + '%)'"
      >
        <img
          [src]="
            image
              | imageVariant: {width: 1920, height: 1080, format: '.webp', quality: 90}
          "
          [alt]="image.description || ''"
          [loading]="i === currentImageIndex() ? 'eager' : 'lazy'"
          class="gallery-image"
        />
      </div>
      }
    </div>
  </div>
  }
</section>
@if (totalImages() > 1) {
<div class="navigation">
  <button class="navigation__button" (click)="previousImage()">
    <app-icon name="chevron-left"></app-icon>
  </button>
  <span>{{ currentImageIndex() + 1 }} / {{ images().length }}</span>
  <button class="navigation__button" (click)="nextImage()">
    <app-icon name="chevron-right"></app-icon>
  </button>
</div>
} }
